"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const ts_validators_1 = require("ts-validators");
const getValueByPathFromUnknown_1 = __importDefault(require("./getValueByPathFromUnknown"));
const timestampToStringFromUnknown = (timestamp, stringFormat, options) => {
    if (!(0, ts_validators_1.valueIsString)(timestamp) && !(0, ts_validators_1.valueIsNumber)(timestamp)) {
        throw new Error('The timestamp property must be a string or number');
    }
    if (!(0, ts_validators_1.valueIsString)(stringFormat)) {
        throw new Error('The stringFormat property must be a string');
    }
    const locale = (0, getValueByPathFromUnknown_1.default)(options, ['locale']);
    if ((0, ts_validators_1.valueIsString)(locale)) {
        moment_1.default.locale(locale);
    }
    return (0, moment_1.default)(timestamp, 'x').format(stringFormat);
};
exports.default = timestampToStringFromUnknown;
